module.exports = __webpack_public_path__ + "img/ZG81_08.f7c20d58.jpg";